
export default {
  methods: {
    fieldVisible(fieldAlias, passSection) {
      let visible = false
      if (this.cfgFormFields[fieldAlias + '-' + passSection]) {
        visible = this.cfgFormFields[fieldAlias + '-' + passSection].pass_kind_visible.includes(this.application.pass_kind) &&
          this.cfgFormFields[fieldAlias + '-' + passSection].section === passSection
      }

      return Boolean(visible)
    },

    fieldTitle(fieldAlias, passSection) {
      let title
      if (
        this.cfgFormFields[fieldAlias + '-' + passSection] &&
        this.cfgFormFields[fieldAlias + '-' + passSection].title
      ) {
        title = this.cfgFormFields[fieldAlias + '-' + passSection].title
      }

      return title
    }
  }
}
